import {mapFilters} from "@/utils/helpers";

const initState = () => ({
})

export const state = initState

export const getters = {
}

export const actions = {

  async createAppraisalPriceQuote({commit}, appraisalPriceQuote){
    let insertedAppraisalPriceQuote = null
    try{
      commit('setOrderCreatingInProgress', true)
      let result = await this.$axios.$post(`/webpos/appraisals/create`, appraisalPriceQuote);
      if(result && result.apiMessages.hasErrors && result.apiMessages.serverErrors.length > 0){
        this.$toast.error(result.apiMessages.serverErrors[0]);
      }
      else if (result.value){
        this.$toast.success("Appraisal created successfully");
        insertedAppraisalPriceQuote = result.value;
      }

    }
    catch(error){
      if(error.response && error.response.data && error.response.data.Message){
        this.$toast.error(error.response.data.Message);
        return;
      }
      this.$toast.error("Error while creating appraisal");
    }
    finally {
      commit('setOrderCreatingInProgress', false)
    }
    return insertedAppraisalPriceQuote;
  },
}
